import { render, staticRenderFns } from "./VersionChangeLog.vue?vue&type=template&id=5db45b9e&scoped=true&"
import script from "./VersionChangeLog.vue?vue&type=script&lang=js&"
export * from "./VersionChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./VersionChangeLog.vue?vue&type=style&index=0&id=5db45b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db45b9e",
  null
  
)

/* custom blocks */
import block0 from "./VersionChangeLog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
